let inject = ['$scope', '$uibModalInstance','modalOptions', 'LoginService', 'SessionService', '$state'];

class ModalSelectBranchController {
  constructor ($scope,$uibModalInstance,modalOptions, LoginService, SessionService, $state) {
    this.$scope = $scope;
    this.LoginService = LoginService;
    this.$state = $state;
    this.SessionService = SessionService;
    this.$uibModalInstance = $uibModalInstance;
    this.modalOptions = Object.assign({}, modalOptions);
    this.state = {};
    this.activate();
  }
  
  activate(){
    if(this.modalOptions.currentBranch){
      this.branchUserB2B = this.modalOptions.currentBranch.id;
    }
  }

  setOperatingCenter (branchId) {
    this.state.saving = true;
    this.LoginService.setOperatingCenter(branchId).then(response => {
      this.state.saving = false;
      this.state.saved = true;
      if (!response.error) {
        // Set the current client
        try {
          this.modalOptions.userData.currentClient.operatingCenter = response.branch;
          this.SessionService.put('globals', this.modalOptions.userData);
        } catch (e) {
          this.state.saving = false;
          this.state.error = true;
        }
        this.$state.go('home.salesHome');
      } else {
        this.state.error = true;
      }
    }).catch(reason => {
      this.state.saving = false;
      this.state.error = true;
    });
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }

  ok() {
    this.$uibModalInstance.close(this.modalOptions.userData);
  }
}

ModalSelectBranchController.$inject = inject;

export default ModalSelectBranchController;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/login/modal-select-branch-b2b-user/modal-select-branch-b2b-user.controller.js
 **/